import AccountsScreen from './AccountsScreen';

export default AccountsScreen;
